module.exports = "/to_the_arctic_for_practice/_next/static/videos/16-07c4e2570e89568b2a42b79cd2dd6899.mp4";